import { useEffect, useState } from "react";
import THEME from "./theme";

// Admin-Warnung zur naechtlichen Milon-CARE-Synchronisierung (Dashboard, nur Administratoren). Zeigt NICHTS, solange alles in Ordnung ist.
// Backend: GET /api/milon/nachtsync/status (routers_milon_nachtsync.py). Bei abgelaufener CARE-Sitzung bleibt der letzte Datenstand erhalten; hier steht dann eindeutig, was zu tun ist.
// Bewusst OHNE Importe aus App.js (nur React + theme.js).
const API = ["localhost", "127.0.0.1"].includes(window.location.hostname)
  ? "http://localhost:8000"
  : `${window.location.protocol}//${window.location.hostname}`;

const FARBE = { kritisch: THEME.colors.danger, hinweis: THEME.colors.warning };

export default function MilonSyncWarnung({ rolle }) {
  const [daten, setDaten] = useState(null);

  useEffect(() => {
    if (rolle !== "admin") return undefined;
    let aktiv = true;
    const laden = () => fetch(`${API}/api/milon/nachtsync/status`, { credentials: "include" })
      .then(r => (r.ok ? r.json() : null)).then(d => { if (aktiv) setDaten(d); }).catch(() => {});
    laden();
    const t = setInterval(laden, 10 * 60 * 1000);
    return () => { aktiv = false; clearInterval(t); };
  }, [rolle]);

  if (rolle !== "admin" || !daten || !daten.warnungen || daten.warnungen.length === 0) return null;
  const farbe = FARBE[daten.stufe] || THEME.colors.warning;
  const stand = daten.datenstand ? new Date(daten.datenstand).toLocaleString("de-DE", { timeZone: "Europe/Berlin", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) + " Uhr" : "unbekannt";
  return (
    <div role="alert" data-testid="milon-sync-warnung" style={{ marginBottom: 16, padding: "14px 18px", borderRadius: THEME.radius.lg, background: THEME.colors.surface, border: `2px solid ${farbe}`, color: THEME.colors.text }}>
      <div style={{ fontWeight: 700, color: farbe, marginBottom: 6, fontSize: THEME.fontSize.md }}>
        {daten.stufe === "kritisch" ? "⚠ Milon-Synchronisierung: Handlungsbedarf" : "Milon-Synchronisierung: Hinweis"}
      </div>
      {daten.warnungen.map(w => <p key={w.code} style={{ margin: "4px 0", fontSize: THEME.fontSize.base, lineHeight: 1.45 }}>{w.text}</p>)}
      <p style={{ margin: "8px 0 0", fontSize: THEME.fontSize.sm, color: THEME.colors.textMuted }}>Letzter erfolgreicher Datenstand: {stand}</p>
    </div>
  );
}
